import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { catchError, throwError } from 'rxjs';

/**
 * 402 `acces_coupe` : TRP a fermé l'espace (abonnement terminé). Toute l'API du BO
 * répond ainsi ; on montre l'écran d'explication au lieu d'une suite d'erreurs.
 * L'erreur est re-propagée.
 */
export const AccesCoupeInterceptor: HttpInterceptorFn = (req, next) => {
  const router = inject(Router);

  return next(req).pipe(
    catchError((error: HttpErrorResponse) => {
      if (error.status === 402 && (error.error as { code?: string } | null)?.code === 'acces_coupe' && !router.url.startsWith('/espace-ferme')) {
        router.navigate(['/espace-ferme']);
      }
      return throwError(() => error);
    })
  );
};
